// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3k00X","header":"ReportDetails_header__1GMD7","title":"ReportDetails_title__1rB1c","left":"ReportDetails_left__2hwyM"};